import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../../common/actions';
import OriginForm from './form';
import './editOrigin.scss';

class EditOrigin extends Component {
  constructor(props) {
    super(props);
    this.onCreateOriginSubmit = this.onCreateOriginSubmit.bind(this);
    this.onEditOriginSubmit = this.onEditOriginSubmit.bind(this);
  }

  async onCreateOriginSubmit(formValues) {
    await this.props.addOrigin(formValues);
    this.props.goBack();
  }

  async onEditOriginSubmit(formValues) {
    const {selectedOrigin} = this.props;
    await this.props.editOrigin(selectedOrigin.code, formValues);
    this.props.goBack();
  }

  render() {
    const {selectedOrigin, goBack, push} = this.props;

    return (
      <OriginForm
        goBack={goBack}
        push={push}
        selectedOrigin={selectedOrigin}
        onSubmit={
          selectedOrigin ? this.onEditOriginSubmit : this.onCreateOriginSubmit
        }
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {code} = ownProps.params;
  const selectedOrigin = state.origin.list.find((item) => item.code === code);
  return {
    selectedOrigin,
    'goBack': ownProps.history.goBack,
    'push': ownProps.history.push,
  };
};

const {addOrigin, editOrigin, withRouter} = Actions;

export default withRouter(
  connect(mapStateToProps, {
    addOrigin,
    editOrigin,
    withRouter,
  })(EditOrigin)
);
